// utils/date/dateRange.ts

/**
 * 📅 Formatea una fecha a YYYY-MM-DD
 * compatible con backend (LocalDate)
 */
export const formatDateToApi = (
  date: Date
): string => {
  return date.toISOString().split("T")[0];
};

/**
 * 📅 Obtiene rango desde hoy
 * hasta X días adelante
 *
 * Ejemplo:
 * getUpcomingDateRange(7)
 */
export const getUpcomingDateRange = (
  daysAhead: number = 7
) => {
  const today = new Date();

  const futureDate = new Date();
  futureDate.setDate(
    today.getDate() + daysAhead
  );

  return {
    dueDateFrom: formatDateToApi(today),
    dueDateTo: formatDateToApi(futureDate),
  };
};